import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthFlowAnalyticsHelper } from '../helpers/auth-analytics.helper';

export const redirectInvalidPvzLinkGuard: CanActivateFn = () => {
  inject(AuthFlowAnalyticsHelper).captureInvalidPvzLinkRedirect();
  return inject(Router).createUrlTree(['/login']);
};
